// Tier → shard look (colour + size). Single source of truth for both the live
// sacrifice renderer (components/three/world/Sacrifices.jsx) and the look-dev
// preview (Shards.jsx). Tier names match the sim (sim-server world/Sacrifices.js
// SacrificeTier). No glow — there's no bloom in the pipe; tier reads from colour
// + size, plus the per-shard tilt/edge-damage variation in Shard.jsx.

// How long an offering may be.
//
// Was 280 in three separate places (the viewer's API route, the dock's
// textarea, and the sim's trusted door), which is three chances to
// disagree. It lives here because this module imports nothing and so
// resolves under both node_modules trees, the same reason tiers and the
// item catalogue live in lib/.
//
// Raised from tweet-length 26 Aug: the ceiling was chosen for brevity,
// and brevity was making people write like forms. A message that sounds
// like a person takes a couple of sentences more than a tweet, and the
// judge reads the whole thing either way.
export const SACRIFICE_TEXT_LIMIT = 600

export const SACRIFICE_TIERS = {
  congregation: { color: '#cdbf9e', scale: 0.85 }, // pale humble shard
  faithful: { color: '#facc15', scale: 0.95 },     // gold
  prophets: { color: '#a78bfa', scale: 1.05 },     // violet
  anointed: { color: '#fde68a', scale: 1.15 },     // radiant cream-gold monument
}

export const DEFAULT_TIER = 'congregation'

export function tierLook(tier) {
  return SACRIFICE_TIERS[tier] || SACRIFICE_TIERS[DEFAULT_TIER]
}
